import { render, staticRenderFns } from "./mdModalBlankBehavioral.vue?vue&type=template&id=48ed48b6&"
import script from "./mdModalBlankBehavioral.vue?vue&type=script&lang=js&"
export * from "./mdModalBlankBehavioral.vue?vue&type=script&lang=js&"
import style0 from "./mdModalBlankBehavioral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports